"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageSummarySchema = exports.UsageRecordSchema = exports.ModelTier = void 0;
const zod_1 = require("zod");
exports.ModelTier = zod_1.z.enum(['lightweight', 'standard', 'premium']);
exports.UsageRecordSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    userId: zod_1.z.uuid(),
    chatId: zod_1.z.string().nullable(),
    provider: zod_1.z.string(),
    model: zod_1.z.string(),
    modelTier: exports.ModelTier,
    promptTokens: zod_1.z.number().int().nonnegative(),
    completionTokens: zod_1.z.number().int().nonnegative(),
    totalTokens: zod_1.z.number().int().nonnegative(),
    creditsConsumed: zod_1.z.number().nonnegative(),
    costUsd: zod_1.z.number().nonnegative(),
    createdAt: zod_1.z.string(),
});
exports.UsageSummarySchema = zod_1.z.object({
    creditsRemaining: zod_1.z.number(),
    creditsUsed: zod_1.z.number(),
    creditsTotal: zod_1.z.number(),
    resetAt: zod_1.z.string(),
    records: zod_1.z.array(exports.UsageRecordSchema).optional(),
});
